/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Grower_Area_Camera_Live_TitleInputs */

const vi_grower_area_camera_live_title = /** @type {(inputs: Grower_Area_Camera_Live_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Xem trực tiếp`)
};

/**

* @param {Grower_Area_Camera_Live_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const grower_area_camera_live_title = /** @type {((inputs?: Grower_Area_Camera_Live_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Grower_Area_Camera_Live_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_grower_area_camera_live_title(inputs)
});